export default __webpack_public_path__ + "static/media/pliers-1.507740f2.png";